import { Box, Button, FormHelperText, Paper } from '@mui/material';
import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import DaysMultipleSelectField from '../../days-multiple-select-field/days-multiple-select-field.component';
import { useSchedulerContext } from '../scheduler-field.hooks';
import { useSchedulerToolbarForm } from './scheduler-toolbar-form.hooks';
import TimeRangePickerField from '../../time-range-picker-field/time-range-picker-field.component';

const SchedulerToolbarForm = () => {
  const { t } = useTranslation();
  const {
    additionalData,
    compact,
    timeFormat,
    addSchedule,
    schedules,
    fieldState,
    schema,
  } = useSchedulerContext();
  const { additionalDataField: AdditionalDataField, additionalDataSchema } =
    additionalData ?? { additionalDataField: null, additionalDataSchema: null };

  const formMethods = useSchedulerToolbarForm(
    schedules,
    additionalDataSchema,
    timeFormat,
    schema,
  );

  const onSubmit = data => {
    addSchedule(data);
    formMethods.reset();
  };

  return (
    <Box>
      <FormProvider {...formMethods}>
        <Box
          component={Paper}
          elevation={3}
          gap={2}
          alignItems="flex-start"
          width="100%"
          p={2}
          display="grid"
          justifyContent="space-between"
          data-testid="SchedulerToolbarForm"
          gridTemplateColumns={{ xs: '1fr', lg: compact ? '1fr' : 'auto auto' }}
        >
          <Box
            gap={2}
            display="grid"
            gridTemplateColumns={{
              xs: '1fr',
              lg: compact ? '1fr' : 'repeat(3, 260px)',
            }}
          >
            <DaysMultipleSelectField
              name="daysOfWeek"
              label={t(
                'forms.fields.schedulerToolBarForm.fields.daysMultipleSelect.label',
              )}
              data-testid="SchedulerToolbarForm.DaysOfWeek.Field"
              TextFieldProps={{ margin: 'none' }}
              optionType="long"
            />
            <TimeRangePickerField
              name="timeRange"
              fromLabel={t(
                'forms.fields.schedulerToolBarForm.fields.timeRange.fromLabel',
              )}
              toLabel={t(
                'forms.fields.schedulerToolBarForm.fields.timeRange.toLabel',
              )}
              data-testid="SchedulerToolbarForm.TimeRange.Field"
            />
            {AdditionalDataField}
          </Box>

          <Button
            data-testid="SchedulerToolbarForm.Submit.Button"
            onClick={formMethods.handleSubmit(onSubmit, e => console.log(e))}
          >
            {t('forms.fields.schedulerToolBarForm.addSchedule.label')}
          </Button>
        </Box>
      </FormProvider>
      {!!fieldState.error && (
        <Box
          component="ul"
          my={0}
          sx={{ pl: '38px' }}
          data-testid="IncFormHelperText.Error"
        >
          <FormHelperText sx={{ mt: 1 }} error={!!fieldState.error}>
            <li>{fieldState.error.message}</li>
          </FormHelperText>
        </Box>
      )}
    </Box>
  );
};

export default SchedulerToolbarForm;
